import axiosInstance from "../../config/Axios";

export const getAmendments = async ({ page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/feedback/amendments/',
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getAmendmentById = async (id) => {
    try {
        const response = await axiosInstance({
            method: 'get',
            url: `/api/feedback/amendments/${id}/`,
        });
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createAmendment = async (amendmentData) => {
    try {
        const response = await axiosInstance({
            method: 'post',
            url: '/api/feedback/amendments/',
            data: amendmentData
        });
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateAmendment = async (id, amendmentData) => {
    try {
        const response = await axiosInstance({
            method: 'put',
            url: `/api/feedback/amendments/${id}/`,
            data: amendmentData
        });
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteAmendment = async (id) => {
    try {
        const response = await axiosInstance({
            method: 'delete',
            url: `/api/feedback/amendments/${id}/`,
        });
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const reviewAmendment = async (id, reviewData) => {
    try {
        const response = await axiosInstance({
            method: 'post',
            url: `/api/feedback/amendments/${id}/review/`,
            data: reviewData
        });
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const submitAmendment = async (projectionId, amendmentData) => {
    try {
      const response = await axiosInstance({
        method: 'post',
        url: `/api/feedback/amendments/${projectionId}/submit/`,
        data: amendmentData
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };